import React, { 
    useState, 
    useEffect  
  } from 'react'
  
  import Navbar from '../../Components/Navbar/Navbar'
  import toast from 'react-hot-toast';

  import { 
      Layout,
      Col, 
      Row,
      Button,
      Space,
      Modal,
      Form,
      Input,
      Table,
      DatePicker,
      Checkbox,
  } from 'antd';
  import { 
    ProductOutlined 
  } from '@ant-design/icons';
  import { UseGetRequest } from '../../Utils/api/ApiRequests' 
  import { usePostRequest } from '../../hooks/usePostRequest'
//   import { useNavigate, useLocation } from "react-router-dom"
  
  const { Item } = Form;
  const { Search } = Input;
  
  const Credit = () => {
    // const navigate = useNavigate();
    // const location = useLocation();
    const [creditForm] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [corporateModal, setCorporateModal] = useState(false);
    const [corporateData, setCorporateData] = useState([]);
    const [filterConfig, setFilterConfig] = useState({
      member_id: '',
      term: '',
    })
    const { callPost, loading } = usePostRequest(()=>{
        creditForm.resetFields();
        setCorporateModal(false);
        fetchCorporateData();
    });

    const customSpinner = <ProductOutlined style={{ fontSize: 24, color: "#005E30"  }} spin />;

    const columns = [
        {
            title: 'Period Covered',
            dataIndex: 'period_date',
            key: 'period_date',
            sorter: (a, b) => a.period_date.localeCompare(b.period_date),
        },
        {
            title: 'Posting Date',
            dataIndex: 'posting_date',
            key: 'posting_date',
            sorter: (a, b) => a.posting_date.localeCompare(b.posting_date),
        
        },
        {
            title: 'Billing Date',
            dataIndex: 'billing_date',
            key: 'billing_date',
            sorter: (a, b) => a.billing_date.localeCompare(b.billing_date),
        
        },
        {
            title: 'Billing Type',
            dataIndex: 'billing_type',
            key: 'billing_type',
            sorter: (a, b) => a.billing_type.localeCompare(b.billing_type),
        
        },
    ];
  
    async function fetchCorporateData() {
      setIsLoading(true);
      const response = await UseGetRequest("corporates/get_member_corporate", filterConfig);
      if (response?.data) {
        setCorporateData(response?.data?.member_corporates);
      } else {
        setCorporateData([]);
      }
      setIsLoading(false);
    }

    const handleAddCorporate = () => {
        creditForm.validateFields().then(values => {
            const newValues = {
                corporate_no: values.corporate_no || ' ',
                name: values.name || ' ',
                address_1: values.address_1 || ' ',
                address_2: values.address_2 || ' ',
                fax: values.fax || ' ',
                telephone: values.telephone || ' ',
                certificate_no: values.certificate_no || ' ',
                email: values.email || ' ',
                nature_of_business: values.nature_of_business || ' ',
            }

            callPost(
                "corporates/create_corporate", 
                newValues,
                false,
            );
        }).catch(errorInfo => { 
          toast.error('Validation Failed ', errorInfo);
        });
    };

    const handleTableChange = (pagination) => {
      setFilterConfig((prev) => ({
        ...prev,
        page: parseInt(pagination.current),
        page_size: pagination.pageSize,
      }));
    };

    const handleChange = (e) => {
        setFilterConfig((prev) => (
          {
            ...prev,
            term: e || '',
            page: 1,
          }
        ));
    };
      
    const handleEmpty = (e) => {
        if(e.target.value === ''){
          setFilterConfig((prev) => (
            {
              ...prev,
              term: e.target.value || '',
              page: 1,
            }
          ));
        }
    };
    
    // useEffect(() => {
    //     if (!corporateModal) {
    //       window.history.replaceState({}, document.title, location.pathname);          
    //       setCorporateModal(false);
    //     }
    // // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [corporateModal]);

      
    useEffect(() => {
        fetchCorporateData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterConfig]);
    
    return (
        <Layout className='page'>
            <Navbar navKey={'credit'}/>
            <Layout className='content-container overflow-y'>
                <Row className='custom-padding responsive-tab-inline'>
                    <Col span={15} className='header-container'>
                        CREDIT
                    </Col>
                    <Col span={9} className='mt-2 responsive-tab-width' align='end'>
                        <Space className='responsive-inline'> 
                            <Search
                                placeholder="Search..."
                                size='medium'
                                onSearch={(e)=>handleChange(e)}
                                onChange={(e)=>handleEmpty(e)}
                                className='responsive-header-input'
                            />        
                            <Button 
                                className='button-color responsive-header-btn' 
                                onClick={() => setCorporateModal(true)} 
                                type="primary"
                            >
                                Generate Billing
                            </Button>         
                        </Space>
                    </Col>
                </Row>
                <Row className='page-content'>
                    <Col span={24} className='responsive-overflow-auto'>
                        <Table 
                            columns={columns} 
                            dataSource={corporateData} 
                            loading={{
                            indicator: customSpinner,
                            spinning: isLoading,
                            }}
                            pagination={{
                            defaultPageSize: 10,
                            //   total: pageSize,
                            current: filterConfig?.page,
                            pageSize: filterConfig?.total_records_per_page,
                            }}
                            onChange={handleTableChange}
                            // onRow={(record, rowIndex) => {
                            //     return {
                            //       className: 'cursor',
                            //       onClick: () => navigate('/corporate/profile/' + record.id),
                            //     };
                            // }}
                        />
                    </Col>
                </Row>
                <Modal
                    title="Add Transaction"
                    open={corporateModal}
                    onOk={handleAddCorporate}
                    onCancel={() => setCorporateModal(false)}
                    okText="Save"
                    maskClosable={false}
                    width={550} 
                    loading={loading}
                >
                    <Form 
                        form={creditForm} 
                        layout="vertical"
                    >
                        <Row>
                            <Col span={24}>
                                <Item
                                    label="Period Covered"
                                    name="date_range"
                                    rules={[{ required: true, message: 'Please select a Period Covered' }]}
                                >
                                    <DatePicker  
                                        style={{width:'100%'}}
                                        picker="month"
                                        placeholder={['Date From', 'Date To']}
                                        format="YYYY-MM"
                                    />
                                </Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Item
                                    label="Posting Date"
                                    name="posting_date"
                                    rules={[{ required: true, message: 'Please select a Posting Date' }]}
                                >
                                    <Input/>
                                </Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Item
                                    label="Billing Date"
                                    name="billing_date"
                                    rules={[{ required: true, message: 'Please select a Billing Date' }]}
                                >
                                    <Input/>
                                </Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={5}>
                                <Checkbox>Jun Golf</Checkbox>
                            </Col>
                            <Col span={10}>
                                <Checkbox>Christmas Contribution</Checkbox>
                            </Col>
                            <Col span={9}>
                                <Checkbox>Annual Registration Fee</Checkbox>
                            </Col>
                        </Row>
                    </Form>
                </Modal>
            </Layout>
        </Layout>
    )
  }
  
  export default Credit
  